import { takeEvery, call, put } from 'redux-saga/effects';
import {
    fetchRolesStart,
    fetchRolesSuccess,
    fetchRolesFail,
    createRoleStart,
    createRoleSuccess,
    createRoleFail,
    updateRoleStart,
    updateRoleSuccess,
    updateRoleFail,
} from '../slices/roleSlice';
import { getRequest, postRequest, putRequest } from '../../network';
import { getRoles, createRole, updateRole } from '../apis';

function* roleSaga(action) {
    const { endpoint, method = 'get', successAction, failAction, payload = null, callback = null } = action.payload;
    const requestFunction = method === 'post' ? postRequest : method === 'put' ? putRequest : getRequest;

    try {
        const response = yield call(requestFunction, endpoint, payload);
        
        if (callback && typeof callback === 'function') {
            yield call(callback, response.message);
        }
        yield put(successAction(response));
    } catch (error) {
        if (callback && typeof callback === 'function') {
            let errorMessage = 'Something went wrong';
            if (error.response && error.response.data) {
                const data = error.response.data;
                if (data.message && data.errors) {
                    errorMessage = `${data.message}: ${data.errors.join(', ')}`;
                } else if (data.message) {
                    errorMessage = data.message;
                }
            } else if (error.message) {
                errorMessage = error.message;
            }
            yield call(callback, errorMessage);
        }
        yield put(failAction(error.message));
    }
}

function* fetchRolesSaga(action) {
    yield roleSaga({
        payload: {
            endpoint: getRoles,
            successAction: fetchRolesSuccess,
            failAction: fetchRolesFail,
            payload: action.payload,
        },
    });
}

function* createRoleSaga(action) {
    yield roleSaga({
        payload: {
            endpoint: createRole,
            method: 'post',
            payload: action.payload?.data,
            callback: action.payload.callback,
            successAction: createRoleSuccess,
            failAction: createRoleFail,
        },
    });
}

function* updateRoleSaga(action) {
    yield roleSaga({
        payload: {
            endpoint: updateRole.replace(':id', action.payload.id),
            method: 'put',
            payload: action.payload.data,
            callback: action.payload.callback,
            successAction: updateRoleSuccess,
            failAction: updateRoleFail,
        },
    });
}
// Watcher saga
export function* watchRole() {
    yield takeEvery(fetchRolesStart.type, fetchRolesSaga);
    yield takeEvery(createRoleStart.type, createRoleSaga);
    yield takeEvery(updateRoleStart.type, updateRoleSaga);
}